<!-- 设施管理 -->
<template>
  <el-main>
    <div class="tableList">
      <div class="search">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item><el-input v-model="formInline.keyWord" clearable placeholder="请输入关键字"></el-input></el-form-item>
          <el-form-item><el-select v-model="formInline.type" placeholder="请选择类型">
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select></el-form-item>
          <el-form-item v-if="formInline.type == 2"><el-select v-model="formInline.category" placeholder="请选择类型">
            <el-option v-for="item in typeChildList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select></el-form-item>
          <el-form-item><el-button type="primary" @click="()=>{ paging.page = 1;this.getList() }" icon="el-icon-search" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}">检索</el-button></el-form-item>
          <div :style="{float:'right'}">
            <el-form-item><el-button size="small" type="primary" icon="el-icon-plus" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="addFacilities">新建</el-button></el-form-item>
            <el-form-item><el-button size="small" type="primary" icon="el-icon-minus" :style="{backgroundColor: $store.state.deleteColor,borderColor: $store.state.deleteColor}" @click="delFacilities">删除</el-button></el-form-item>
          </div>
        </el-form>
      </div>
      <div class="tableContent">
        <el-table
          @selection-change="handleSelectionChange"
          row-key="id"
          class="table"
          ref="tableData"
          :data="table.tableData"
          border
          :height="table.tableHeight"
          element-loading-text="拼命加载中,请等待"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <el-table-column width="45" type="selection" :reserve-selection="true" align="center"></el-table-column>
          <el-table-column width="100" prop="id" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ (paging.page-1)*paging.size+scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称" align="center"></el-table-column>
          <el-table-column prop="type" label="类型" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.type == 1?'房间设施':'公寓楼设施'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="category" label="公寓楼设施再分类" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.category == 1">公共设施</span>
              <span v-if="scope.row.category == 2">公寓服务</span>
              <span v-if="scope.row.category == 3">室外设施</span>
              <span v-if="scope.row.category == 4">安保设施</span>
            </template>
          </el-table-column>
          <el-table-column prop="icon" label="图标" align="center">
            <template slot-scope="scope">
              <el-image style="width: 40px; height: 40px;display: block;margin: 0 auto" :src="scope.row.iconImg" fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="140" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleOperation('edit', scope.row)" icon="el-icon-edit" :style="{color: $store.state.activeColor}">编辑</el-button>
              <el-popconfirm class="real_pop" title="您确定要删除设施信息吗？" @confirm="handleOperation('remove', scope.row)">
                <el-button class="danger" slot="reference" type="text" size="mini" :icon="scope.row.status ? 'el-icon-circle-check':'el-icon-circle-close'">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tablePagination">
        <el-pagination
          class="customPagination"
          @size-change="handlePaginationChange"
          @current-change="handlePaginationCurrentChange"
          :current-page="paging.page"
          :page-sizes="[15, 25, 50]"
          :page-size="paging.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paging.total"
        >
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'FacilitiesManagement',
    data () {
      return {
        formInline: { // 查询参数
          keyWord: '', // 关键字
          type: '', // 类型
          category: '1' // 公寓楼类型
        },
        table: { // 表格参数
          tableData:[], // 表格数据
          tableHeight: null, // 表格高度
        },
        paging: { // 分页参数
          page: 1,// 页码
          size: 15, // 条数
          total: 0, // 总数
        },
        checkIds:[], // 所选列表
        typeList:[{label:'全部',value:''},{label:'房间设施',value:'1'},{label:'公寓楼设施',value:'2'}], // 类型列表
        typeChildList:[{label:'公共设施',value:'1'},{label:'公寓服务',value:'2'},{label:'室外设施',value:'3'},{label:'安保设施',value:'4'}], // 类型列表
      }
    },
    methods: {
      // 获取表格数据
      getList(){
        if(this.formInline.type == "" || this.formInline.type == "1"){
          this.formInline.category = "";
        }
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        },{
          "field":"name",
          "fun":"like",
          "value": this.formInline.keyWord
        },{
          "field":"type",
          "fun":"like",
          "value": this.formInline.type
        }, {
          "field":"category",
          "fun":"like",
          "value": this.formInline.category
        }, {
          "field": "type,category",
          "fun": "orderByAsc"
        }];
        this.$api.findFacilities({
          page:this.paging.page,
          size:this.paging.size,
          parameter: JSON.stringify(parameter)
        }).then(res => {
          if (res.data.status == 200) {
            this.table.tableData = res.data.data.records;
            for (let i = 0 ; i < this.table.tableData.length; i++){
              if (this.table.tableData[i].icon != null){
                if (this.table.tableData[i].icon.toLowerCase().indexOf('.jpg') > -1 || this.table.tableData[i].icon.toLowerCase().indexOf('.png') > -1 || this.table.tableData[i].icon.toLowerCase().indexOf('.jpeg') > -1 || this.table.tableData[i].icon.toLowerCase().indexOf('.gif') > -1){
                  this.table.tableData[i].iconImg = api_url + "/" +this.table.tableData[i].icon;
                }
              }
            }
            this.paging.total = Number(res.data.data.total);
            if(this.table.tableData != ""){
              this.$nextTick(() => {
                this.$refs.tableData.clearSelection();
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 分页部分改变条数
      handlePaginationChange(val) {
        this.paging.size = val;
        this.paging.page = 1;
        this.getList();
      },
      // 分页部分改变页码
      handlePaginationCurrentChange(val) {
        this.paging.page = val;
        this.getList();
      },
      // 切换选择
      handleSelectionChange(val) {
        this.checkIds = [];
        if (val.length > 0) {
          for (let i = 0; i < val.length; i++) {
            this.checkIds.push(val[i].id);
          }
        }
      },
      // 新建Facilities
      addFacilities(){
        this.$router.push({
          path:'/FacilitiesManagementOperation'
        });
      },
      // 批量删除Facilities
      delFacilities(){
        for(let i = 0 ; i < this.table.tableData.length; i++){
          for(let j = 0; j < this.checkIds.length; j++){
            if (this.checkIds[j] == this.table.tableData[i].id){
              this.table.tableData[i].status = 0;
            }
          }
        }
        this.setBatch('批量删除成功！');
      },
      // 批量添加修改列表
      setBatch(title){
        this.$api.saveOrUpdateFacilitiesBatch({ parameter: JSON.stringify(this.table.tableData)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: title,
              type: 'success'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
        this.$api.deleteHouseFacilities({ids: this.checkIds.toString() }).then(res => {});
      },
      // 编辑/删除
      handleOperation(type,row){
        if (type == "edit") {  // 编辑操作
          this.$router.push({
            path:'/FacilitiesManagementOperation',
            query:{ data:row }
          });
        } else if (type == "remove") { // 删除操作
          for(let i = 0 ; i < this.table.tableData.length; i++){
            if (row.id == this.table.tableData[i].id){
              this.table.tableData[i].status = 0;
            }
          }
          this.setBatch('删除成功！');
        }
      },
      // table的高度
      getTableHeight(){
        let that = this;
        if($(".table").length > 0) {
          // 表格高度初始化事件
          $(".table").height(window.innerHeight - $(".table").offset().top - 70);
          $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
          that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
          // 窗口改变事件
          window.onresize = function () { // 定义窗口大小变更通知事件
            if($(".table").length > 0) {
              $(".table").height(window.innerHeight - $(".table").offset().top - 70);
              $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
              that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
            }
          };
        }
      },
    },
    mounted() {
      // 获取页面表格高度
      this.getTableHeight();
      // 获取列表
      this.getList();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/FacilitiesManagement.vue